import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TaxClassificationsProvider } from '../providers/tax-classifications.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface GetTaxClassificationsParams {
    classification: string;
    isLegalPerson: boolean;
}

@Injectable()
export class GetTaxClassificationsUseCase implements UseCaseWithParam<GetTaxClassificationsParams, Observable<Transaction<string[]>>> {
    constructor(private taxClassificationsProvider: TaxClassificationsProvider) {}

    bind(params: GetTaxClassificationsParams): Observable<Transaction<string[]>> {
        return this.taxClassificationsProvider.find(params.classification, params.isLegalPerson).pipe(
            map((transaction) =>
                transaction.map(
                    (taxClassifications) => Transaction.success(cloneDeep(taxClassifications)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
